import React, {createContext, useContext, useState} from 'react';

const authContextProvider = createContext({});

export const useAuthContext = () => useContext(authContextProvider);

const AuthContextProvider = ({children}) => {
    const [user, setUser] = useState({});
    const [token, setToken] = useState("");

    return (
        <authContextProvider.Provider value={{user, token, setUser, setToken}}>
            {children}
        </authContextProvider.Provider>
    )
};

export default AuthContextProvider;